module.exports = __webpack_public_path__ + "media/icons/dart board3-d8ca7329.png";